import React from 'react';
import Yup from '~/util/yup';
import { updateLegacyReferralOptions, type SearchLegacyReferralViewModel } from '@generated';
import { TextAreaFormField } from '~/shared/forms/controls/fields/text-fields/TextAreaFormField';
import { FormModal } from '~/shared/forms/FormModal';
import { useQueryClient } from '@tanstack/react-query';
import { getSearchQueryKey } from '~/util/http/useSearch';

const validationSchema = Yup.object().shape({
	referralNotes: Yup.string().label('Notes').nullable()
});

export function UpdateLegacyReferralModal({ referral, closeModal }: { referral: SearchLegacyReferralViewModel; closeModal: () => void }) {
	const queryClient = useQueryClient();

	return (
		<FormModal
			title="Update Referral"
			initialValues={{
				referralId: referral.id,
				referralNotes: referral.referralNotes ?? ''
			}}
			saveMutation={updateLegacyReferralOptions}
			onSuccess={() => {
				queryClient.invalidateQueries({ queryKey: getSearchQueryKey('legacy-referral') });
				closeModal();
			}}
			validationSchema={validationSchema}
			closeModal={closeModal}
		>
			<TextAreaFormField name="referralNotes" />
		</FormModal>
	);
}
